<template>
  <div class="container pt-4 mb-4 ImpressaoPecas">
    <!--    <b-modal v-model="modalHipossuficiencia"
             centered
             hide-footer
             no-close-on-backdrop
             hide-header
             no-close-on-esc
             title="Atenção">
      <h4>Atenção</h4>
      <p class="my-4">
        <span class="custom-control custom-switch">
          &lt;!&ndash;<input
            id="declaracao_de_hipossuficiencia"
            ref="declaracao_de_hipossuficiencia"
            v-model="declaracao_pobreza"
            class="custom-control-input"
            name="hipossuficiencia"
            type="checkbox"
            @keyup.enter="changeFlagDeclaracao()"
            @change="changeDeclaracao()">&ndash;&gt;
          <input
            id="declaracao_de_hipossuficiencia"
            v-model="declaracao_pobreza"
            class="custom-control-input"
            name="hipossuficiencia"
            type="checkbox"
            @change="changeDeclaracao()">
          <label
            class="custom-control-label"
            for="declaracao_de_hipossuficiencia">Adicionar Declaração de Hipossuficiência</label>
        </span>
      </p>
      <hr>
      <div class="text-right">
        <button class="btn btn-sm btn-secondary"
                @click="modalHipossuficiencia = false">
          Fechar
        </button>
      </div>
    </b-modal>

    <div v-if="propHabilitacao.tipo_casamento != 'Conversão de união estável em casamento'"
         class="form-group">
      <span class="custom-control custom-switch">
        <input
          id="declaracao_de_hipossuficiencia"
          v-model="declaracao_pobreza"
          class="custom-control-input"
          name="hipossuficiencia"
          type="checkbox"
          @change="changeDeclaracao()">
        <label
          class="custom-control-label label"
          for="declaracao_de_hipossuficiencia"><h6>Adicionar Declaração de Hipossuficiência</h6></label>
      </span>
    </div>
    <hr class="ImpressaoPecas&#45;&#45;hr">-->
    <b-modal id="memorial-preview"
             ref="memorial-preview"
             size="xl">
      <object v-if="filePreview != null"
              class="embed-responsive"
              style="height: 400px; position: relative"
              :data="`${filePreview}#toolbar=0&navpanes=0&scrollbar=0`"
              type="application/pdf">
        <p>Seu browser não suporta arquivos pdf diretamente ou este arquivo não existe. Você pode tentar efetuar o download clicando.</p>
      </object>
      <template v-slot:modal-footer>
        <div class="w-100">
          <div class="float-right">
            <b-button
              size="sm"
              class="mr-1"
              variant="default"
              @click="$bvModal.hide('memorial-preview')">
              Voltar
            </b-button>
            <b-button
              variant="secondary"
              size="sm"
              class="ml-1"
              @click="imprimir()">
              Imprimir
            </b-button>
          </div>
        </div>
      </template>
    </b-modal>

    <div id="botoes_edicao"
         :class="{
           'bt-scroll-top':resize.value < 200,
           'bt-scroll-float':resize.value > 200
         }">
      <div v-b-tooltip.hover.left="'Imprimir'"
           class="mt-2">
        <b-button class="Termo--btn-info"
                  style="padding: 6px 5.5px;"
                  @click="printPreview">
          <icon-svg class="icon--xxs icons--white"
                    style="height: 1.3rem;width: 1.3rem;"
                    icon="print" />
        </b-button>
      </div>

      <div v-b-tooltip.hover.left="'Aumentar zoom'"
           class="mt-1">
        <b-button class="Termo--btn-info"
                  style="padding: 6px 5.5px;"
                  :disabled="zoom > 1"
                  @click="zoom++">
          <icon-svg class="icon--xxs icons--white"
                    style="height: 1.3rem;width: 1.3rem;color:white;"
                    icon="zoomPlus" />
        </b-button>
      </div>

      <div v-b-tooltip.hover.left="'Menos zoom'"
           class="mt-1">
        <b-button class="Termo--btn-info"
                  style="padding: 6px 5.5px;"
                  :disabled="zoom < 1"
                  @click="zoom--">
          <icon-svg class="icon--xxs icons--white"
                    style="height: 1.3rem;width: 1.3rem;"
                    icon="zoomMinus" />
        </b-button>
      </div>

      <div v-b-tooltip.hover.left="'Voltar ação'"
           class="mt-1">
        <b-button class="ImpressaoPecas--btn-no-select"
                  @click="exec($event,'undo')">
          <span><</span>
        </b-button>
      </div>

      <div v-b-tooltip.hover.left="'Próxima ação'"
           class="mt-1">
        <b-button class="ImpressaoPecas--btn-no-select"
                  @click="exec($event,'redo')">
          >
        </b-button>
      </div>

      <div v-if="edit"
           v-b-tooltip.hover.left="'Negrito'"
           class="mt-1">
        <b-button class="ImpressaoPecas--btn-no-select"
                  :class="{'ImpressaoPecas--btn-selected':state.bold}"
                  @click="exec($event,'bold')">
          <b>B</b>
        </b-button>
      </div>

      <div v-if="edit"
           v-b-tooltip.hover.left="'Itálico'"
           class="mt-1">
        <b-button class="ImpressaoPecas--btn-no-select"
                  :class="{'ImpressaoPecas--btn-selected':state.italic}"
                  @click="exec($event,'italic')">
          <i>It</i>
        </b-button>
      </div>

      <div v-if="edit"
           v-b-tooltip.hover.left="'Sublinhado'"
           class="mt-1">
        <b-button class="ImpressaoPecas--btn-no-select"
                  :class="{'ImpressaoPecas--btn-selected':state.underline}"
                  @click="exec($event,'underline')">
          <u>U</u>
        </b-button>
      </div>
    </div>

    <!--<div class="row justify-content-end">
      <div class="col-3">
        <select class="form-control form-control-sm">
          <option>Memorial</option>
          <option>Declaração de Hipossuficiência</option>
          <option>Certidão de Habilitação</option>
        </select>
      </div>
    </div>-->

    <div class="row">
      <div class="col ImpressaoPecas--fundoBlack pt-2 pb-2">
        <div class="ImpressaoPecas--pagina"
             :class="{'ImpressaoPecas-zoom-2': zoom == 2, 'ImpressaoPecas-zoom-1': zoom == 1}"
             @click="getState"
             @keyup="getState">
          <div v-html="html" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* others */
  import { mapGetters } from "vuex"

  /* services */
  import HabilitacaoService from "@/services/Registros/Habilitacao"

  export default {
    name: "ImpressaoPecas",
    computed: {
      ...mapGetters({
        resize: 'window/getScroll',
      }),
    },
    props: {
      propRegistro: {
        type: Boolean,
        default: false
      },
      propHabilitacao: {
        type: Object,
        default: () => {}
      }
    },
    data () {
      return {
        modalHipossuficiencia: true,
        zoom: 1,
        html: null,
        filePreview: null,
        state: {
          undo: false,
          redo: false,
          bold: false,
          italic: false,
          underline: false
        },
        edit: false,
        declaracao_pobreza: false
      }
    },
    watch: {
      propHabilitacao () {
        this.getDeclaracao()
      }
    },
    created () {
      this.getDeclaracao()
      this.loadTemplate()

      setTimeout(() => {
        this.$refs.declaracao_de_hipossuficiencia.focus()
      }, 100)
    },
    methods: {
      async loadTemplate () {
        try {
          loader({ text: "Carregando template...", active: true })
          const params = {
            registro_id: this.propHabilitacao.registro_id,
            declaracao_pobreza: this.declaracao_pobreza
          }

          // caso já seja um registro não mostramos modal
          if (!!this.declaracao_pobreza || this.$route.name == 'editar_habilitacao_casamento') {
            this.modalHipossuficiencia = false
          }

          if (this.propRegistro && this.propHabilitacao) {
            const template = await HabilitacaoService.getTemplateMemorialRegistro(this.$route.params.id, params)
            this.html = template
          } else {
            const template = await HabilitacaoService.getTemplateMemorial(this.$route.params.id, params)
            this.html = template
          }
        } catch (e) {
          console.error('Erro ao carregar template do memorial', e)
        } finally {
          loader({ active: false })
        }
      },

      async printPreview () {
        try {
          loader({ text: "Gerando preview...", active: true })
          this.filePreview = null
          const html = document.querySelector('.pagina-margin').innerHTML
          const pdfFile = await HabilitacaoService.getMemorialPDF(html, true)
          let blob = new Blob([pdfFile], { type: 'application/pdf' })
          let url = window.URL.createObjectURL(blob)
          this.filePreview = url
          this.$refs['memorial-preview'].show()
          console.log(url)
        } catch (e) {
          console.error('Erro ao gerar preview do memorial', e)
        } finally {
          loader({ active: false })
        }
      },
      getDeclaracao () {
        this.declaracao_pobreza = this.propHabilitacao.declaracao_pobreza
      },
      changeFlagDeclaracao () {
        this.declaracao_pobreza = !this.declaracao_pobreza
        this.changeDeclaracao()
      },


      exec ( event, command, value = null ) {
        document.execCommand(command, false, value)

        this.state = {
          undo: this.statusExec('undo'),
          redo: this.statusExec('redo'),
          bold: this.statusExec('bold'),
          italic: this.statusExec('italic'),
          underline: this.statusExec('underline'),
        }
      },

      statusExec (command) {
        let status = document.queryCommandState(command)
        return status
      },

      getState (event) {
        if (event.target.contentEditable == "true" ||
          event.target.parentElement.contentEditable == "true" ||
          event.target.parentElement.parentElement.contentEditable == "true" ||
          event.target.parentElement.parentElement.parentElement.contentEditable == "true") {
          this.edit = true
        } else {
          this.edit = false
        }

        this.state = {
          undo: this.statusExec('undo'),
          redo: this.statusExec('redo'),
          bold: this.statusExec('bold'),
          italic: this.statusExec('italic'),
          underline: this.statusExec('underline'),
        }
      },

      changeDeclaracao () {
        this.declaracao_pobreza = !!this.declaracao_pobreza
        this.$emit('onChangeDeclaracao', this.declaracao_pobreza)
        this.loadTemplate()
      },

      async imprimir () {
        try {
          loader({ text: "Preparando download...", active: true })
          const haha = document.querySelector('.pagina-margin').innerHTML
          const pdfFile = await HabilitacaoService.getMemorialPDF(haha)
          let blob = new Blob([pdfFile], { type: 'application/pdf' })
          let url = window.URL.createObjectURL(blob)

          window.open(url)
        } catch (e) {
          console.error('Erro ao realizar download do arquivo PDF', e)
        } finally {
          loader({ active: false })
        }
      },

      download (url, title) {
        var a = document.createElement("a")
        document.body.appendChild(a)
        a.href = url

        a.download = title

        a.click()
        a.remove()
      }
    }
  }
</script>

<style lang="scss">
  @import "./src/scss/_utilities/variables";

  .ImpressaoPecas {
    &--hr{
      border: 1px solid $sinoreg-header-color;
    }

    &--fundoBlack {
      background-color: black;
      height: 100%;
    }

    &--pagina {
      height: 100% !important;
      width: 210mm !important;
      margin: 10px auto !important;
    }
    &--btn-no-select{
      background-color: $color-gray;
      border-color: gray;
      color: white;
    }

    &--btn-selected{
      background-color: $sinoreg-blue;
      border-color: $sinoreg-blue;
      color: white;
    }

    &-zoom-2{
      transform: scale(1.2);
      margin-top: 12.4em !important;
      margin-bottom: 12.4em !important;
    }

    &-zoom-1{
      transform: scale(1.1);
      margin-top: 6.5em !important;
      margin-bottom: 6.5em !important;
    }
  }
</style>
